<!-- 在线咨询 -->
<template>
  <div class="online">
    <!-- 咨询 -->
    <van-nav-bar
      :title="`${params.title}律师`"
      fixed
      placeholder
      z-index="10"
      @click-left="goBack(0)"
      @click-right="goBack(1)"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
      <template #right>
        <img src="@/assets/img/position/backHome.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 聊天部分 -->
    <div class="chat-rome" ref="box">
      <!-- <span class="nowTime">下午5：00</span> -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <span
            :class="{'layer':item.type==2,'mine':item.type==1}"
            v-for="(item, index) in list"
            :key="index"
          >{{item.content}}</span>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 发送 -->
    <div class="send">
      <div class="slfe">
        <input type="text" class="send-input" v-model="value" />
        <button class="send-btn" @click="send">发送</button>
      </div>
    </div>
  </div>
</template>

<script>
import { messageList, sendMessage } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  inject:['Token'],
  data() {
    return {
      params: {}, //路由传参
      page: 0,
      totalPages: 1,
      offset: 10,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      value: "" //内容
    };
  },
  computed: {},
  methods: {
    // 返回
    goBack(val) {
      if (val == 0) {
        this.$router.back();
      } else {
        this.$router.replace({
          name: "Index"
        });
      }
    },
    // 上拉加载
    onLoad() {
      this.getMessageList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = true;
      that.list = [];
      that.getMessageList();
      setTimeout(() => {
        that.refreshing = false;
      }, 1500);
    },
    // 获取消息列表
    getMessageList() {
      var that = this;
      let { params, page, offset, totalPages, list } = that;
      var obj = {
        lawyer_id: params.id,
        page: page + 1,
        offset: offset
      };
      if (totalPages > page) {
        messageList(obj).then(res => {
          //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.page = page + 1;
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            if (res.data.list.length == 0) {
              setTimeout(() => {
                that.loading = false;
                that.finished = true;
              }, 1500);
              return false;
            }
            if (that.list.length > list.length) {
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          }else{
            // Toast.fail(res.msg)
            // setTimeout(()=>{
            //   that.$router.back();
            // },2000)
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    },
    // 发送
    send() {
      var that = this;
      var value = that.value;
      var params = that.params;
      if (value.replace(/[, ]/g, "").length == 0) {
        Toast("请输入需要咨询的内容~");
        return false;
      }
      var obj = {
        lawyer_id: params.id,
        content: value
      };
      sendMessage(obj).then(res => {
        //(res);
        if (res.code == 1) {
          that.value='';
          that.page = 0;
          that.totalPages = 1;
          that.loading = false;
          that.finished = false;
          that.refreshing = false;
          that.list = [];
          that.getMessageList();
          Toast('发送成功')
        }
      });
    }
  },
  created() {
    this.params = this.$route.query;
  },
  mounted() {
    this.Token();
    this.getMessageList();
  },
  updated() {
    this.$nextTick(() => {
      let div = this.$refs.box;
      div.scrollTop = div.scrollHeight;
    });
  }
};
</script>
<style lang='less' scoped>
.chat-rome {
  background: #f7f7f7;
  min-height: 12rem;
  padding: 0 0.32rem;

  width: 100%;
  .nowTime {
    display: block;
    text-align: center;
    font-size: 0.22rem;
    font-weight: 400;
    line-height: 0.3rem;
    color: rgba(153, 153, 153, 1);
    padding: 0.5rem 0 0.32rem;
  }
  .van-list {
    display: flex;
    flex-direction: column;
    .layer {
      width: 80%;
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      background: #fff;
      border-radius: 0 0.5rem 0.5rem 0.4rem;
      padding: 0.26rem 0.3rem;
      margin-bottom: 0.57rem;
      box-shadow: 0 0 0.05rem 0.01rem rgba(0, 0, 0, 0.1);
    }
    .mine {
      width: 80%;
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      background: #ff4343;
      border-radius: 0.5rem 0 0.4rem 0.5rem;
      padding: 0.26rem 0.3rem;
      align-self: flex-end;
      margin-bottom: 0.57rem;
      color: #fff;
    }
  }
}
.send {
  width: 100%;
  .slfe {
    padding: 0.2rem 0.32rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    .send-input {
      flex: 6;
      border-radius: 0.2rem;
      background: #f7f7f7;
      font-size: 0.3rem;
      padding: 0.1rem 0.2rem;
    }
    .send-btn {
      flex: 1;
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.4rem;
      color: rgba(153, 153, 153, 1);
      background: #fff;
    }
  }
}
.send::before {
  content: "";
  display: block;
  height: 1rem;
  width: 100%;
  background: #f7f7f7;
}
</style>